import { render } from "./BalanceCorrectionModal.vue?vue&type=template&id=71d0df28&ts=true"
import script from "./BalanceCorrectionModal.vue?vue&type=script&lang=ts"
export * from "./BalanceCorrectionModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__